import { EVO } from "../EVO";
import AuthService from "../AuthService";
import { urls } from "../urls";
import produce from "immer";


export const withEnsure = data => {
    data = data || {};
    data.ensure = ensure;
    return data;
};

const GET_ENSURES = 'peptalkr/Ensures/GET_ENSURE';
const GET_ENSURES_SUCCESS = 'peptalkr/Ensures/GET_ENSURE_SUCCESS';
const GET_ENSURES_FAILURE = 'peptalkr/Ensures/GET_ENSURE_FAILURE';

export const requestEnsures = () => ({ type: GET_ENSURES });
export const receiveEnsures = (response, id) => ({ type: GET_ENSURES_SUCCESS, response, id });
export const receiveEnsuresFail = error => ({ type: GET_ENSURES_FAILURE, error });


export const ensure = (ens) => (dispatch) => {
    const authService = new AuthService();
    if (authService.isAuthenticated()) {
        dispatch(requestEnsures());
        EVO.fetch(urls.api.ensure.get(ens))
            .then(response => {
                dispatch(receiveEnsures(response));
            })
            .catch(error => dispatch(receiveEnsuresFail(error)));
    }
};

export const updateModel = (model) => (dispatch) => {
    dispatch(receiveEnsures(model));
}

export const ensureId = (ens, id) => (dispatch) => {
    const authService = new AuthService();
    if (authService.isAuthenticated()) {
        dispatch(requestEnsures());
        EVO.fetch(urls.api.ensure.get(ens))
            .then(response => {
                dispatch(receiveEnsures(response, id));
            })
            .catch(error => dispatch(receiveEnsuresFail(error)));
    }
};

const initialState = {
    practitioners: [],
    appointmentTypes: [],
    appointmentCategories: [],
    ensureLoading: true,
    ensureError: false,
    smsCredit: 0,
    appointmentModelProperties: [],
    products: [],
    businesses: [],
    billableItems: [],
    ptProducts: [],
    medicalAlerts: [],
    cmEmails: [],
    paysGst: true
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_ENSURES:
            draft.ensureLoading = true;
            return;
        case GET_ENSURES_SUCCESS:
            draft.ensureLoading = false;
            var response = action.response;
            if (response.practitioners) {
                draft.practitioners = response.practitioners;
            }

            if (response.appointmentTypes) {
                draft.appointmentTypes = response.appointmentTypes;
            }

            if (response.appointmentCategories) {
                draft.appointmentCategories = response.appointmentCategories;
            }

            if (response.appointmentModelProperties) {
                draft.appointmentModelProperties = response.appointmentModelProperties;
            }

            if (response.products) {
                draft.products = response.products;
                if (action.id) {
                    draft.product = EVO.getDetailsItemById(response.products, action.id);
                }
                draft.paysGst = response.paysGst;
            }

            if (EVO.canBeZero(response.smsCredit)) {
                draft.smsCredit = response.smsCredit;
            }

            if (response.billableItems) {
                draft.billableItems = response.billableItems;
            }

            if (response.businesses) {
                draft.businesses = response.businesses;
            }

            if (response.sexes) {
                draft.sexes = response.sexes;
            }

            if (response.ptProducts) {
                draft.ptProducts = response.ptProducts;
            }

            if (response.medicalAlerts) {
                draft.medicalAlerts = response.medicalAlerts;
            }

            if (response.cmEmails) {
                draft.cmEmails = response.cmEmails;
            }

            return;
        case GET_ENSURES_FAILURE:
            draft.ensureLoading = false;
            draft.ensureError = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/ensure.js